export const PEEK_WBS_DIALOG = {
  DIALOG: 'peek-wbs-dialog',
  DIALOG_TITLE: 'peek-wbs-dialog-title',
  SEARCH_INPUT: 'peek-wbs-dialog-search-input',
  SEARCH_CLEAR_BUTTON: 'peek-wbs-dialog-search-clear-button',
  CLOSE_BUTTON: 'peek-wbs-dialog-close-button'
} as const;
